var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'calendar__calendar',
    _vm.requestPending ? 'calendar__calendar--requestpending' : ''
]},[(_vm.requestPending)?[_c('div',{staticClass:"calendar__calendar_loading"},[_c('component-loading')],1)]:_vm._e(),_c('div',{ref:"calendar",staticClass:"calendar__calendar_table"}),(_vm.dialogActive)?_c('calendar-calendar-dialog',{attrs:{"item":_vm.selectedItem}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }